import { useMemo } from 'react';
/* eslint-disable */
const createMemo = <T extends (...args: any) => any>(fn: T) => 
  (...args: Parameters<T>) => 
  useMemo<ReturnType<T>>(() => fn(...args), args);
/* eslint-enable */
export default createMemo;
